import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import Drawer from '@material-ui/core/Drawer';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';
import Grid from '../Grid';
import HexaPicto from '../HexaPicto';
import Container from '../../containers/Container';

const BASE_URL = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? '' : process.env.PUBLIC_URL;

class Menu extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { open: false, credits: false };
    this.onOpen = this.onOpen.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onClick = this.onClick.bind(this);
    this.openCredit = this.openCredit.bind(this);
    this.closeCredit = this.closeCredit.bind(this);
  }

  openCredit() {
    this.setState({ credits: true, open: false });
  }

  closeCredit() {
    this.setState({ credits: false, open: false });
  }

  onOpen() {
    this.setState({ open: true });
  }

  onClose() {
    this.setState({ open: false });
  }

  onClick(id) {
    if (id === 'home-first') {
      window.scrollTo(0, 0);
    } else {
      const element = document.getElementById(id);
      if (element && element.offsetTop) {
        window.scroll({ top: element.offsetTop, behavior: 'smooth' });
      }
    }
    this.onClose();
  }

  renderCredits() {
    const { classes, data } = this.props;
    const block = data.credits;
    const { credits } = this.state;
    return (
      <Dialog
        maxWidth="md"
        fullWidth
        scroll="paper"
        open={credits}
        onClose={this.closeCredit}
        PaperProps={{ square: true, className: classes.dialogPaper }}
      >
        <DialogTitle className={classes.dialogTitle}>
          <Grid justify="space-between">
            <Typography key="title" variant="h4">
              {parse(block.title)}
            </Typography>
            <IconButton key="icon" color="inherit" onClick={this.closeCredit} className={classes.dialogClose}>
              <HexaPicto width={35} height={35} type="cross" color="blueLight2" />
            </IconButton>
          </Grid>
          <div className={classes.dialogSep}></div>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          {block.list.map((p, id) => (
            <div key={id} className={classes.dialogParagraph}>
              <Typography variant="subtitle1" className={classes.dialogSubTitle}>
                {parse(p.title)}
              </Typography>
              {p.list.map((name, idx) => (
                <Typography variant="body2" key={idx} className={classes.dialogName}>
                  {parse(name)}
                </Typography>
              ))}
            </div>
          ))}
        </DialogContent>
      </Dialog>
    );
  }

  renderMenu() {
    const { classes, route, data } = this.props;
    const { open } = this.state;
    const list = data.menu[route];
    return (
      <Drawer
        anchor="top"
        open={open}
        onClose={this.onClose}
        className={classes.drawerDesk}
        PaperProps={{ className: classes.drawerDeskPaper }}
      >
        <IconButton key="icon" color="inherit" onClick={this.onClose} className={classes.drawerClose}>
          <HexaPicto width={35} height={35} type="cross" color="blueLight2" />
        </IconButton>
        <Container maxWidth="lg" className={classes.drawerDeskContainer}>
          {route !== 'home' ? (
            <React.Fragment key="home">
              <Typography to={`${BASE_URL}/`} className={classes.drawerDeskLabel} component={Link}>
                {parse(data.menu['back-home'])}
              </Typography>
              <span className={classes.drawerDeskLabelSep}></span>
            </React.Fragment>
          ) : null}
          {map(list, (value, key) => (
            <React.Fragment key={key}>
              <Typography onClick={() => this.onClick(key)} className={classes.drawerDeskLabel}>
                {parse(value)}
              </Typography>
              <span className={classes.drawerDeskLabelSep}></span>
            </React.Fragment>
          ))}
          <Typography onClick={this.openCredit} className={classes.drawerDeskLabel}>
            {data.credits.button}
          </Typography>
        </Container>
      </Drawer>
    );
  }

  render() {
    const { classes } = this.props;
    return (
      <>
        <div className={classes.buttonContainer}>
          <IconButton color="inherit" onClick={this.onOpen}>
            <MenuIcon fontSize="large" />
          </IconButton>
        </div>
        {this.renderMenu()}
        {this.renderCredits()}
      </>
    );
  }
}

Menu.propTypes = {
  classes: PropTypes.object.isRequired,
  route: PropTypes.string,
  data: PropTypes.object.isRequired,
};

export default withStyles(styles)(Menu);
